import React from 'react'
import { Redirect, Route, Switch } from 'react-router'
import { ROUTES } from '../App'
import MenuWithDrawer from "../components/layout/menuWithDrawer/menuWithDrawer";
import MenuWrapper from "../components/layout/menuWithDrawer/menuWrapper";
import NotFound from "../pages/notFound/notFound";

const ContentRouter = () => {
	return (
		<Switch>
			{ROUTES.map(route => {
				const { key, path, exact, component } = route;
				const Component = component
				return (
					<Route
						key={key}
						path={path}
						exact={exact}
						render={() => (
							<MenuWithDrawer>
								<MenuWrapper>
									<Component/>
								</MenuWrapper>
							</MenuWithDrawer>
						)}
					/>
				)
			})}
			<Redirect from={'/login'} to={'/'}/>
			<Route path={'/'}>
				<NotFound/>
			</Route>
		</Switch>
	)
}

export default ContentRouter